import { FC } from 'app/FunctionalComponent'
import React from 'react'
import { Icon, solidIcons } from 'ui/components/common/icon'
import { theme } from 'ui/theme'

export const StationFail: FC = (props: {}) => {
	return (
		<div
			data-testid='subway-station-fail'
			className={`${theme.getTextColor('red')}`}
		>
			<Icon icon={solidIcons.faTimesCircle} />
		</div>
	)
}
